module.exports = __webpack_public_path__ + "static/media/7H.6aac8e37.svg";